import { SlButton, SlInput } from '@shoelace-style/shoelace/dist/react'
import React, { useEffect, useState } from 'react'
import ScrollContainer from 'react-indiana-drag-scroll'
import TableSkelton from '../../shared/TableSkelton'
import NoDataFound from '../../shared/NoDataFound'
import API from '../../services/api'
import ZoneCreation from './ZoneCreation'
import { Toast } from '../../shared/Toast'
import { formatDateDDMMYYY } from '../../utils/dateFormat'
import { debounce } from '../../utils/Debounce'

function Zones() {
    const [showAdd, setShowAdd] = useState(false)
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([])
    const [flag, setFlag] = useState('add')
    const [search, setSearch] = useState('')
    const [editData, setEditData] = useState({})
    const handleAdd = () =>{
        setShowAdd(true)
        setFlag('add')
        setEditData({})
    }
    const loadData = async() =>{
        try {
            setLoading(true)
            let res = await API({
                url:'/zones/get',
                method:'POST',
                responseType:'json',
                data:{
                    search
                }
            })
            if(res.code === 200){
                setData(res.data)
            }
        } catch (error) {
            console.error(error)
        }
        finally{
            setLoading(false)
        }
    }
    const toggleStatus = async(status, zone_id)=>{
        try {
            let res = await API({
                url:'/zones/status',
                method:'POST',
                responseType:'json',
                data:{
                    status,zone_id
                }
            })
            if(res.code === 200){
                Toast('success', "Status update Successfull!")
                loadData()
            }
        } catch (error) {
            console.error(error)
        }
    }
    const searchData = (e)=>{
        setSearch(e.target.value);
    }
    useEffect(()=>{
        loadData()
    },[search])
  return (
    <>
        <h5 className='my-2'>Zones</h5>
        <aside className='d-flex gap-3 justify-end items-center'>
                <SlInput size='small' type='text' placeholder='Enter zone name'  value={search}
                            onSlInput={debounce(searchData, 500)}></SlInput>
                <SlButton  variant='primary' size='small' onclick={handleAdd}>Add Zone</SlButton>
        </aside>
        <ScrollContainer>
            <table className='table table-bordered mt-3'>
                <thead className='bg-gray-300'>
                    <tr>
                        <th>S.No</th>
                        <th>Zone Name</th>
                        <th>Language</th>
                        <th>States</th>
                        <th>Districts</th>
                        <th>Constituencies</th>
                        <th>Created On</th>
                        <th>Status</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                {
                    (!loading && data.length > 0) ?  <tbody>
                        {data.map((row, index)=>(
                            <tr key={row.zone_id}>
                                <td>{index+1}</td>
                                <th>{row.zone_name}</th>
                                <td>{row.lang_id === 1 ? 'Telugu' : 'Tamil'}</td>
                                <td>{row.state_names?.join(", ")}</td>
                                <td>{row.district_names?.join(", ")}</td>
                                <td>{row.constituency_names?.join(", ")}</td>
                                <td>{formatDateDDMMYYY(row.created_on)}</td>
                                <td ><div className="form-check form-switch" style={{ marginLeft: '1rem' }}>
                                            <input className="form-check-input" type="checkbox" role="switch" checked={row.status} onChange={(e) => { toggleStatus(row.status, row.zone_id) }} />
                                        </div></td>
                                <td>
                                    <div className='d-flex gap-3'>
                                            <sl-tooltip content="Edit Zone">
                                            <sl-icon-button
                                    library="lucide"
                                    name="edit"
                                    onClick={() => {
                                      setShowAdd(true)
                                      setFlag("edit");
                                    setEditData(row)
                                    }}
                                  ></sl-icon-button>
                                            </sl-tooltip>
                                    </div>
                                </td>
                            </tr>   
                        ))}
                    </tbody> : loading ? <TableSkelton colspan={9} /> : <NoDataFound colspan={9} />

                }
            </table>
        </ScrollContainer>


    <ZoneCreation show={showAdd} setShow={setShowAdd}  loadData={loadData} flag={flag} editData={editData}/>
    </>
  )
}

export default Zones